import { makeAutoObservable, runInAction } from 'mobx'

class LayoutStore {
  private _disablePadding: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get disablePadding() {
    return this._disablePadding
  }

  set disablePadding(value: boolean) {
    runInAction(() => {
      this._disablePadding = value
    })
  }
}

export const layoutStore = new LayoutStore()
